// apps/web/src/lib/constants.ts
// Use empty string for same-origin (production) or localhost for dev
export const API_BASE = import.meta.env.VITE_API_BASE ?? ''
export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? ''
export const PAGE_SIZE = 30
export const MSG_PAGE_SIZE = 50
